import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore } from '@app-auth/data-access/auth.store';

export const DomainGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  if (!authStore.isLoggedIn()) {
    router.navigate(['/common/login']).then();
  }
  return authStore.isLoggedIn();
};
